import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AppRoutes } from "@/app/router";
import { AppProviders } from "@/app/providers/AppProviders";
import Navbar from "@/features/marketing/components/Navbar";
import Footer from "@/features/marketing/components/Footer";
import { getSavedTheme, applyThemeColor } from "@/utils/theme";

function AppContent() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");

  useEffect(() => {
    const saved = getSavedTheme();
    applyThemeColor(saved.id);
  }, []);

  if (isDashboard) {
    return (
      <div className="h-[100dvh] w-screen overflow-hidden bg-background-50">
        <AppRoutes />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <AppRoutes />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AppProviders>
      <AppContent />
    </AppProviders>
  );
}

export default App;
